<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 1" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 1
        }}</a>
      </el-form-item>
      <el-form-item
        label="实际承运人隐私协议"
        prop="privacyAgreementDriver"
        style="margin-right:15px"
      >
        <myEditor v-model="form.privacyAgreementDriver" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 2" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 2
        }}</a>
      </el-form-item>
      <el-form-item
        label="实际承运人服务协议"
        prop="userAgreementDriver"
        style="margin-right:15px"
      >
        <myEditor v-model="form.userAgreementDriver" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 4" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 4
        }}</a>
      </el-form-item>
      <el-form-item
        label="运输协议"
        prop="logisticsAgreementDriver"
        style="margin-right:15px"
      >
        <myEditor v-model="form.logisticsAgreementDriver" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 5" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 5
        }}</a>
      </el-form-item>
      <el-form-item
        label="运输交易协议"
        prop="receiveAgreement"
        style="margin-right:15px"
      >
        <myEditor v-model="form.receiveAgreement" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 6" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 6
        }}</a>
      </el-form-item>
      <el-form-item
        label="sdk协议"
        prop="sdkAgreementDriver"
        style="margin-right:15px"
      >
        <myEditor v-model="form.sdkAgreementDriver" :disabled="false" />
      </el-form-item>
      <el-form-item label="访问地址">
        <a :href="agreementUrl + 3" target="_blank" rel="noopener noreferrer">{{
          agreementUrl + 3
        }}</a>
      </el-form-item>
      <el-form-item
        label="实际承运人注销协议"
        style="margin-right:15px"
        prop="cancelAgreementDriver"
      >
        <myEditor v-model="form.cancelAgreementDriver" :disabled="false" />
      </el-form-item>

      <el-form-item label="访问地址">
        <a
          :href="agreementUrl + 16"
          target="_blank"
          rel="noopener noreferrer"
          >{{ agreementUrl + 16 }}</a
        >
      </el-form-item>
      <el-form-item
        label="车龄性质挂靠协议"
        style="margin-right:15px"
        prop="affiliationAgreementDriver"
      >
        <myEditor v-model="form.affiliationAgreementDriver" :disabled="false" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";

export default {
  name: "SiteEdit",
  components: {
    myEditor
  },
  data() {
    return {
      agreementUrl:
        this.BASE_API_URL + "agreement/agreement.html?agreementType=",
      form: {
        code: "",
        privacyAgreementDriver: "",
        userAgreementDriver: "",
        logisticsAgreementDriver: "",
        receiveAgreement: "",
        sdkAgreementDriver: "",
        cancelAgreementDriver: "",
        affiliationAgreementDriver: ""
      },
      rules: {
        privacyAgreementDriver: [
          { required: true, message: "请输入隐私协议", trigger: "blur" }
        ],
        cancelAgreementDriver: [
          { required: true, message: "请输入注销协议", trigger: "blur" }
        ],
        logisticsAgreementDriver: [
          { required: true, message: "请输入物流协议", trigger: "blur" }
        ],
        userAgreementDriver: [
          { required: true, message: "请输入服务协议", trigger: "blur" }
        ],
        receiveAgreement: [
          { required: true, message: "请输入运输交易协议", trigger: "blur" }
        ],
        sdkAgreementDriver: [
          { required: true, message: "请输入SDK协议", trigger: "blur" }
        ],
        affiliationAgreementDriver: [
          { required: true, message: "请输入车龄性质挂靠协议", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const rLoading = this.openLoading("获取数据中...");
      return request({
        url: `/ntocc-basic-api/agreement/getAgreement`,
        params: { agreementType: 2 },
        method: "get"
      }).then(response => {
        if (response.data) {
          this.form.code = response.data.code;
          this.form.privacyAgreementDriver =
            response.data.privacyAgreementDriver;
          this.form.userAgreementDriver = response.data.userAgreementDriver;
          this.form.logisticsAgreementDriver =
            response.data.logisticsAgreementDriver;
          this.form.receiveAgreement = response.data.receiveAgreement;
          this.form.sdkAgreementDriver = response.data.sdkAgreementDriver;
          this.form.cancelAgreementDriver = response.data.cancelAgreementDriver;
          this.form.affiliationAgreementDriver =
            response.data.affiliationAgreementDriver;
        }
        rLoading.close();
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/agreement/saveAgreement",
            method: "post",
            data
          }).then(response => {
            this.getInfo();
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
